module.exports = __webpack_public_path__ + "static/img/code.9376113.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/code.png
// module id = xDq9
// module chunks = 0